import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from "../img/no_pages.svg";
import { Link, useParams } from "react-router-dom";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";
import { PlusLg } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { useIsNoShared } from "../../../../hooks/useIsNoShared";

type Props = {
  domainId: string;
  folderId: string;
};

const NoPages: React.FC<Props> = ({ domainId, folderId }) => {
  const lng = useGetUrlLocale();
  const { t } = useTranslation();
  const isNoShared = useIsNoShared();
  const { projectId, id } = useParams();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const createFolderLink = folderId
    ? `${lng}/folder/new?parentFolder=${folderId}`
    : `${lng}/folder/new?parentDomain=${domainId}`;

  const reportWindowSize = () => {
    if (window.innerWidth >= 768) {
      setIsMobile(false);
    } else {
      setIsMobile(true);
    }
  };

  useEffect(() => {
    reportWindowSize();

    window.addEventListener("resize", reportWindowSize);
  }, []);

  return (
    <div className="rounded-1 bg-white mt-4">
      <Container>
        <Row>
          <Col
            lg={10}
            xl={6}
            className="noPages mx-auto d-flex flex-column align-items-center text-dark-gray p-4 py-md-5 text-center"
          >
            <div className="mb-4 mb-md-5">
              <img
                src={Image}
                alt="No Projects"
                loading="lazy"
                className="img-fluid"
              />
            </div>
            <h4 className="mb-1 mb-md-4 text-capitalize">
              {t("projects.noPages")}
            </h4>
            <p className="text-gray col-lg-5 mx-auto mb-4 mb-md-5 fs-7">
              {t("projects.noPagesDescription")}
            </p>
            <div className="col-10 mx-auto">
              <div className="d-flex justify-content-center">
                <Col className="buttomCol text-nowrap me-3 me-md-4">
                  {" "}
                  <Link
                    to={{
                      pathname: `${lng}/page/create`,
                      search: `?type=${isMobile ? "2" : "1"}${id ? `&parentFolder=${id}` : ""}${projectId ? `&projectId=${projectId}` : ""}${!isNoShared ? `&Shared` : ""}`,
                    }}
                    className="btn btn-primary w-100 text-white px-4 px-md-3"
                  >
                    <PlusLg className="me-2" />
                    <p className="d-none d-md-inline">
                      {t("projects.newPage")}
                    </p>
                    <p className="d-inline d-md-none">
                      {t("projects.createPage")}
                    </p>
                  </Link>
                </Col>
                <Col className="buttomCol text-nowrap">
                  {" "}
                  <Link
                    to={createFolderLink}
                    className="btn btn-outline-primary primary-hover fw-normal text-primary bg-primary-light w-100 px-4 px-md-3"
                  >
                    <PlusLg className="me-2" />
                    <p className="d-none d-md-inline">
                      {t("projects.newFolder")}
                    </p>
                    <p className="d-inline d-md-none">
                      {t("projects.createFolder")}
                    </p>
                  </Link>
                </Col>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default NoPages;
